const constants = window.ENV as Window["ENV"];

if (window.Cypress) {
  constants["GRAPHQL_API_URL"] = "/api/graph";
  constants["CHAT_API_URL"] = "";
  constants["CHAT_WS_URL"] = "";
  constants["CHAT_MEDIA_S3_REGION"] = "";
  constants["CHAT_MEDIA_S3_BUCKET"] = "";
  constants["TYPEFORM_LIVE_EVENTS_ID"] = "M7L0VtX9";
  constants["TYPEFORM_AUTOMATED_GAMES_ID"] = "ZQNNpf6F";
  constants["RAILS_ENV"] = "testing";
  constants["TYPEFORM_CHANNEL_REQUEST_ID"] = "rgb3FvVb";
  constants["FEEDBACK_FORM_URL"] = "";
}

export { constants };
